import React, { useEffect, useMemo } from 'react';
import PageHeader from 'components/common/general/layouts/PageHeader';
import useEnrollmentQuoteUrlParams from 'global/hooks/useEnrollmentQuoteUrlParams';
import PageFooter from 'components/common/general/layouts/PageFooter';
import OverrideRatesProposalPlans from 'components/proposal-override-rates';
import ProposalOverrideRatesPageStore, {
  ProposalOverrideRatesPageStoreContext,
  useProposalOverrideRatesPageStore,
} from 'store/pages/proposal-override-rates/pageStore';
import { NarrowPageWrapperStyled } from '../../globalStyles';

const PageBody: React.FC = () => {
  const { getInitialData } = useProposalOverrideRatesPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return <OverrideRatesProposalPlans />;
};

const ProposalOverrideRatesPage: React.FC = () => {
  const { periodId, groupId, cartId } = useEnrollmentQuoteUrlParams();

  const pageStore = useMemo(
    () => new ProposalOverrideRatesPageStore({ enrollmentPeriodId: periodId, groupId, cartId }),
    [],
  );

  return (
    <NarrowPageWrapperStyled>
      <ProposalOverrideRatesPageStoreContext.Provider value={pageStore}>
        <PageHeader
          title="Override Rates"
          subtitle="Choose the product and the specific version where you want to override or adjust the final rates"
          subtitleMaxWidth="55%"
          onRedirect={pageStore.returnBack}
        />
        <PageBody />
        <PageFooter onBack={pageStore.returnBack} />
      </ProposalOverrideRatesPageStoreContext.Provider>
    </NarrowPageWrapperStyled>
  );
};

export default ProposalOverrideRatesPage;
